import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            你可能想了解的问题
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h4 className="text-sm font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </h4>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-foreground-500 transition-transform duration-200 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}